// TODO: split components up into signup card and signup page
// TODO: move generic components into separate components
import React from "react";

import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as yup from "yup";

import { Box, Stack, Typography } from "@mui/material";

import SettingsHeader from "@app/analytics/account/components/SettingsHeader";
import { Button } from "@app/analytics/account/components/styles";
import useAuth from "@app/common/auth/useAuth";
import ROUTES from "@app/common/routes";
import { yupResolver } from "@app/utils/forms/yupResolver";
import { getStringType } from "@app/utils/utils";

import PasswordField from "./PasswordField";
import { CenteredContainer } from "./styles";
import { PASSWORD_REGEX } from "./utils";
import SettingsCard from "../account/components/SettingsCard";

const resetPasswordValidationSchema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters.")
    .matches(PASSWORD_REGEX, {
      message: "Password must contain at least one special character.",
    }),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match."),
});

const ResetPassword = () => {
  const auth = useAuth();
  const [queryParams] = useSearchParams();
  const navigate = useNavigate();

  const onSubmit = (data: any) => {
    const token: string | null = queryParams.get("token");
    auth.resetPassword({
      token: token,
      newPassword: data.password,
      confirmPassword: data.confirmPassword,
    });
  };

  const formResolver = yupResolver(resetPasswordValidationSchema);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ resolver: formResolver });

  return (
    <>
      <Box
        sx={{
          bgcolor: "#F1F4FF",
          height: "100%",
          width: "100%",
          minHeight: "100vh",
          position: "absolute",
          zIndex: "-1",
        }}
      />
      <CenteredContainer>
        <Box
          sx={{
            mb: "28px",
            width: {
              md: 518,
            },
          }}
        >
          <SettingsHeader title="Reset password" />
          <SettingsCard sx={{ overflow: "hidden" }}>
            <Stack spacing={2}>
              <Typography
                variant="bodySecondaryReg"
                sx={{ textAlign: "left", color: "shades.neutral.500" }}
              >
                In order to protect your account, ensure your new password:
                <ul>
                  <li>Contains at least 8 characters</li>
                  <li>Includes a special symbol !@#$%^&*()</li>
                  <li>
                    Is not a password you have previously used for this account
                  </li>
                </ul>
              </Typography>
            </Stack>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack
                spacing={1}
                alignItems="start"
                justifyContent="start"
                sx={{ maxWidth: "400px", my: 2 }}
              >
                <PasswordField
                  label="New Password"
                  InputProps={{ ...register("password") }}
                  error={!!errors.password}
                  helperText={getStringType(errors.password?.message)}
                />
                <PasswordField
                  label="Confirm New Password"
                  InputProps={{ ...register("confirmPassword") }}
                  error={!!errors.confirmPassword}
                  helperText={getStringType(errors.confirmPassword?.message)}
                />
              </Stack>
              <Stack direction="row">
                <Button
                  sx={{ mr: 1 }}
                  primary
                  onClick={() => setValue("action", "email")}
                  type="submit"
                  loading={auth.isLoading}
                >
                  Reset password
                </Button>
                <Button onClick={() => navigate(ROUTES.LANDING_PAGE)}>
                  Cancel
                </Button>
              </Stack>
            </form>
          </SettingsCard>
        </Box>
      </CenteredContainer>
    </>
  );
};

export default ResetPassword;
